import styled from 'styled-components'

export const Container = styled.div`
  position: relative;
  width: 100%;
  max-width: 1300px;
  margin: 0 auto;
`

export const WrapperContainer = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0px;
  left: 0px;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
  h2 {
    font-size: 14px;
    margin: 0;
    margin-top: 1.5rem;
  }
  @media only screen and (min-width: 1100px) {
    h2 {
      margin-bottom: 0.5rem;
    }
  }
  @media only screen and (min-width: 1400px) {
    h2 {
      margin-bottom: -3%;
    }
  }
`

export const ModalWelcomeSubscription = styled.div`
  background: ${({ theme }) => `rgb(${theme.background.high})`};
  border-radius: 16px;
  width: 100vw;
  height: 100vh;
  min-width: 300px;
  border: solid 0.1px rgba(186, 186, 186, 1);
  overflow-y: auto;
  padding: 0 1rem;
  hr {
    display: none;
    opacity: 0.3;
  }

  @media only screen and (min-width: 700px) {
    height: auto;
  }

  @media only screen and (min-width: 1090px) {
    width: 60%;
    border-radius: 3px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    hr {
      display: flex;
      width: 100%;
    }
  }
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
  border-radius: 16px;

  h1 {
    margin: 0;
    font-size: 22px;
    font-weight: bolder;
  }
  h2 {
    margin: 12px 0 0 0;
    font-weight: 400;
  }
  button {
    border: none;
    background-color: transparent;
    color: black;
    font-size: 19px;
  }
`

export const OkButton = styled.button`
  position: relative;
  background: #ff6600 !important;
  color: #ffffff !important;
  padding: 0.5rem 2rem;
  border-radius: 4px;
  margin: 2rem auto !important;

  font-weight: 800;
`
